import { render, staticRenderFns } from "./Index2.vue?vue&type=template&id=78dd08f2&scoped=true&"
import script from "./Index2.vue?vue&type=script&lang=js&"
export * from "./Index2.vue?vue&type=script&lang=js&"
import style0 from "./Index2.vue?vue&type=style&index=0&id=78dd08f2&prod&lang=scss&"
import style1 from "./Index2.vue?vue&type=style&index=1&id=78dd08f2&prod&lang=scss&scoped=true&"
import style2 from "./Index2.vue?vue&type=style&index=2&id=78dd08f2&prod&lang=scss&"
import style3 from "./Index2.vue?vue&type=style&index=3&id=78dd08f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dd08f2",
  null
  
)

export default component.exports